/* eslint-disable*/
import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import Swal from "sweetalert2";
import { Link, useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faArrowUp,
  faPlus,
  faTrash,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import LoadingSpinner from "../../components/LoadingSpinner";

const WebsiteServiceForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    // Section 1
    title: "",
    uniqueKey: "",
    sub_headline: "",
    highlight_1: "",
    highlight_2: "",
    highlight_3: "",
    highlight_4: "",
    step_1: "",
    step_2: "",
    step_3: "",
    step_4: "",

    // Section 2
    title_2: "",

    // Section 3
    heading_3: "",
    sub_heading_3: "",
    CuratedSelection: "",
    FundamentalAnalysis: "",
    TechnicalValidation: "",

    // Section 4
    title_4: "",
    sub_title_4: "",
    bulletPoints_1: "",
    bulletPoints_2: "",
    bulletPoints_3: "",
    cta_text: "",
    cta_link: "",

    // Other
    other_service: [],
    service_id: id || "",
  });

  const [iconFields, setIconFields] = useState([]);
  const [stages, setStages] = useState({
    CuratedSelection: [],
    FundamentalAnalysis: [],
    TechnicalValidation: [],
  });
  const [otherServices, setOtherServices] = useState([]);
  const [fileUploads, setFileUploads] = useState({
    bulletPoints_file_1: null,
    bulletPoints_file_2: null,
    bulletPoints_file_3: null,
  });

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");

        if (id && id !== "0") {
          // Fetch website service data
          const response = await axios.get(
            `${API_URL}service/website-add?id=${id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          if (response.data) {
            const data = response.data;
            const mainData = data.data?.main || {};
            const safeParse = (str) => {
              if (!str) return {};
              try {
                let parsed = JSON.parse(str);
                // If the result is still a string, parse it again (handle double encoding)
                if (typeof parsed === "string") {
                  parsed = JSON.parse(parsed);
                }
                return parsed;
              } catch (e) {
                console.error("Error parsing JSON:", e);
                return {};
              }
            };

            const highlights = safeParse(mainData.highlights);
            const steps = safeParse(mainData.steps);

            // Set main form data
            setFormData((prev) => ({
              ...prev,
              title: mainData.title || "",
              uniqueKey: mainData.uniqueKey || "",
              sub_headline: mainData.sub_headline || "",
              highlight_1: highlights.highlight_1 || "",
              highlight_2: highlights.highlight_2 || "",
              highlight_3: highlights.highlight_3 || "",
              highlight_4: highlights.highlight_4 || "",
              step_1: steps.step_1 || "",
              step_2: steps.step_2 || "",
              step_3: steps.step_3 || "",
              step_4: steps.step_4 || "",
              title_2: mainData.title_2 || "",
              heading_3: mainData.heading_3 || "",
              sub_heading_3: mainData.sub_heading_3 || "",
              CuratedSelection: mainData.CuratedSelection || "",
              FundamentalAnalysis: mainData.FundamentalAnalysis || "",
              TechnicalValidation: mainData.TechnicalValidation || "",
              title_4: mainData.title_4 || "",
              sub_title_4: mainData.sub_title_4 || "",
              bulletPoints_1: mainData.bulletPoints_1 || "",
              bulletPoints_2: mainData.bulletPoints_2 || "",
              bulletPoints_3: mainData.bulletPoints_3 || "",
              cta_text: mainData.cta_text || "",
              cta_link: mainData.cta_link || "",
              other_service: Array.isArray(mainData.other_service)
                ? mainData.other_service.map((item) => item.id)
                : mainData.other_service
                  ? mainData.other_service.split(",").map(Number)
                  : [],
              service_id: mainData.service_id || id,
            }));

            // Set icon fields
            if (data.data?.sec2_icon) {
              setIconFields(
                data.data.sec2_icon.map((icon) => ({
                  id: icon.id,
                  description: icon.description,
                  file_path: icon.file_path,
                  existingFile: icon.file_path,
                }))
              );
            }

            // Set stages
            if (data.data?.stages) {
              const newStages = {
                CuratedSelection: [],
                FundamentalAnalysis: [],
                TechnicalValidation: [],
              };

              data.data.stages.forEach((stage) => {
                if (newStages[stage.stage_type]) {
                  newStages[stage.stage_type].push({
                    id: stage.id,
                    sub_title: stage.sub_title,
                    description: stage.description,
                  });
                }
              });

              setStages(newStages);
            }
          }
        }

        // Fetch other services for dropdown from a fixed service ID (14)
        const otherServicesResponse = await axios.get(
          `${API_URL}service/website-add?id=14`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (otherServicesResponse.data && otherServicesResponse.data.other_service) {
          setOtherServices(otherServicesResponse.data.other_service);
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        // showToast.error("Failed to load website service data");
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFileUploads((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

  const handleOtherServiceChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      other_service: selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [],
    }));
  };

  const addIconField = () => {
    setIconFields((prev) => [
      ...prev,
      {
        id: 0,
        description: "",
        file_path: "",
        existingFile: "",
      },
    ]);
  };

  const updateIconField = (index, field, value) => {
    setIconFields((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const removeIconField = (index) => {
    setIconFields((prev) => prev.filter((_, i) => i !== index));
  };

  const handleIconFileChange = (index, e) => {
    const file = e.target.files[0];
    setIconFields((prev) => {
      const updated = [...prev];
      updated[index].file_path = file;
      updated[index].existingFile = "";
      return updated;
    });
  };

  const addStageField = (stageType) => {
    setStages((prev) => ({
      ...prev,
      [stageType]: [
        ...prev[stageType],
        {
          id: 0,
          sub_title: "",
          description: "",
        },
      ],
    }));
  };

  const updateStageField = (stageType, index, field, value) => {
    setStages((prev) => ({
      ...prev,
      [stageType]: prev[stageType].map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));
  };

  const removeStageField = (stageType, index) => {
    setStages((prev) => ({
      ...prev,
      [stageType]: prev[stageType].filter((_, i) => i !== index),
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setSaving(true);

  //   try {
  //     const token = localStorage.getItem("authToken");
  //     const formDataToSend = new FormData();

  //     // Add main form data
  //     Object.keys(formData).forEach((key) => {
  //       if (key === "other_service") {
  //         formDataToSend.append(key, formData[key].join(","));
  //       } else {
  //         formDataToSend.append(key, formData[key]);
  //       }
  //     });

  //     // Prepare highlights and steps as JSON strings
  //     const highlights = {
  //       highlight_1: formData.highlight_1,
  //       highlight_2: formData.highlight_2,
  //       highlight_3: formData.highlight_3,
  //       highlight_4: formData.highlight_4,
  //     };

  //     const steps = {
  //       step_1: formData.step_1,
  //       step_2: formData.step_2,
  //       step_3: formData.step_3,
  //       step_4: formData.step_4,
  //     };

  //     formDataToSend.append("highlights", JSON.stringify(highlights));
  //     formDataToSend.append("steps", JSON.stringify(steps));

  //     // Add icon fields
  //     iconFields.forEach((icon, index) => {
  //       formDataToSend.append(`icon_ids[]`, icon.id);
  //       formDataToSend.append(`descriptions[]`, icon.description);
  //       if (icon.file_path instanceof File) {
  //         formDataToSend.append(`icon_files[]`, icon.file_path);
  //       } else if (icon.existingFile) {
  //         formDataToSend.append(`existing_icon_paths[]`, icon.existingFile);
  //       }
  //     });

  //     // Add stages
  //     Object.keys(stages).forEach((stageType) => {
  //       stages[stageType].forEach((stage, index) => {
  //         formDataToSend.append(`stage_types[]`, stageType);
  //         formDataToSend.append(`stage_ids[]`, stage.id);
  //         formDataToSend.append(`sub_titles[]`, stage.sub_title);
  //         formDataToSend.append(`descriptions[]`, stage.description);
  //       });
  //     });

  //     // Add file uploads
  //     Object.keys(fileUploads).forEach((key) => {
  //       if (fileUploads[key]) {
  //         formDataToSend.append(key, fileUploads[key]);
  //       }
  //     });

  //     // Send the request
  //     await axios.post(`${API_URL}service/website-save`, formDataToSend, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     showToast.success("Website service saved successfully!");
  //     navigate("/Research/Services");
  //   } catch (err) {
  //     console.error("Error saving website service:", err);
  //     showToast.error(
  //       err.response?.data?.message || "Failed to save website service"
  //     );
  //   } finally {
  //     setSaving(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const token = localStorage.getItem("authToken");
      const formDataToSend = new FormData();

      // Add main form data
      Object.keys(formData).forEach((key) => {
        if (key === "other_service") {
          formDataToSend.append(key, formData[key].join(","));
        } else if (
          // Skip these as they'll be sent in highlights/steps objects
          !key.startsWith("highlight_") &&
          !key.startsWith("step_")
        ) {
          formDataToSend.append(key, formData[key]);
        }
      });

      // Prepare highlights and steps as JSON strings
      const highlights = {
        highlight_1: formData.highlight_1,
        highlight_2: formData.highlight_2,
        highlight_3: formData.highlight_3,
        highlight_4: formData.highlight_4,
      };

      const steps = {
        step_1: formData.step_1,
        step_2: formData.step_2,
        step_3: formData.step_3,
        step_4: formData.step_4,
      };

      formDataToSend.append("highlights", JSON.stringify(highlights));
      formDataToSend.append("steps", JSON.stringify(steps));

      // Add sec2_loop (number of icon fields)
      formDataToSend.append("sec2_loop", iconFields.length);

      // Add sub_icons (renamed from icon fields)
      iconFields.forEach((icon, index) => {
        // Create a sub_icons array structure
        const subIcon = {
          icon_id: icon.id,
          description: icon.description,
        };

        // If there's a new file, append it
        if (icon.file_path instanceof File) {
          formDataToSend.append(`sub_icon_files[]`, icon.file_path);
          formDataToSend.append(`sub_icons[${index}][icon_id]`, icon.id);
          formDataToSend.append(`sub_icons[${index}][description]`, icon.description);
          formDataToSend.append(`sub_icons[${index}][has_new_file]`, 'true');
        } else if (icon.existingFile) {
          // If using existing file
          formDataToSend.append(`sub_icons[${index}][icon_id]`, icon.id);
          formDataToSend.append(`sub_icons[${index}][description]`, icon.description);
          formDataToSend.append(`sub_icons[${index}][file_path]`, icon.existingFile);
          formDataToSend.append(`sub_icons[${index}][has_new_file]`, 'false');
        }
      });

      // Add stages (renamed from individual stage types)
      const allStages = [];
      Object.keys(stages).forEach((stageType) => {
        stages[stageType].forEach((stage) => {
          allStages.push({
            stage_type: stageType,
            stage_id: stage.id,
            sub_title: stage.sub_title,
            description: stage.description,
          });
        });
      });

      // Append stages as array
      allStages.forEach((stage, index) => {
        formDataToSend.append(`stages[${index}][stage_type]`, stage.stage_type);
        formDataToSend.append(`stages[${index}][stage_id]`, stage.stage_id);
        formDataToSend.append(`stages[${index}][sub_title]`, stage.sub_title);
        formDataToSend.append(`stages[${index}][description]`, stage.description);
      });

      // Add file uploads for bullet points
      Object.keys(fileUploads).forEach((key) => {
        if (fileUploads[key]) {
          formDataToSend.append(key, fileUploads[key]);
        }
      });

      // Send the request
      await axios.post(`${API_URL}service/website-save`, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      showToast.success("Website service saved successfully!");
      navigate("/Research/Services");
    } catch (err) {
      console.error("Error saving website service:", err);
      showToast.error(
        err.response?.data?.message || "Failed to save website service"
      );
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  const operation = id !== "0" ? "Edit" : "Add";
  const managePage = `${operation} Website Services`;

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="row pb-2">
          <div className="col-md-6">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="/Dashboard">
                  <FontAwesomeIcon icon={faHome} /> Home
                </a>
              </li>
              <li className="breadcrumb-item active">Manage Service</li>
            </ul>
          </div>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          <form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="stdform"
          >
            <div className="panel-heading">
              <span className="panel-title">{managePage}</span>
            </div>
            <hr />
            <input type="hidden" name="id" value={id} />
            <input
              type="hidden"
              name="service_id"
              value={formData.service_id}
            />

            <div className="panel-body">
              {/* Section 1 */}
              <div className="panel-heading">
                <span className="panel-title">Section 1</span>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      name="title"
                      className="form-control"
                      value={formData.title}
                      onChange={handleInputChange}
                      placeholder="Enter Title"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Unique Key</label>
                    <input
                      type="text"
                      name="uniqueKey"
                      className="form-control"
                      value={formData.uniqueKey}
                      onChange={handleInputChange}
                      placeholder="Enter Unique Key"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Sub Headline</label>
                    <input
                      type="text"
                      name="sub_headline"
                      className="form-control"
                      value={formData.sub_headline}
                      onChange={handleInputChange}
                      placeholder="Enter Sub Headline"
                    />
                  </div>
                </div>

                {/* Highlights */}
                {[1, 2, 3, 4].map((num) => (
                  <div key={num} className="col-md-3">
                    <div className="form-group">
                      <label>Highlights {num}</label>
                      <input
                        type="text"
                        name={`highlight_${num}`}
                        className="form-control"
                        value={formData[`highlight_${num}`]}
                        onChange={handleInputChange}
                        placeholder={`Enter Highlights ${num}`}
                      />
                    </div>
                  </div>
                ))}

                {/* Steps */}
                {[1, 2, 3, 4].map((num) => (
                  <div key={num} className="col-md-3">
                    <div className="form-group">
                      <label>Step {num}</label>
                      <input
                        type="text"
                        name={`step_${num}`}
                        className="form-control"
                        value={formData[`step_${num}`]}
                        onChange={handleInputChange}
                        placeholder={`Enter Step ${num}`}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <hr />

              {/* Section 2 */}
              <div className="panel-heading mt-2">
                <span className="panel-title">Section 2</span>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      name="title_2"
                      className="form-control"
                      value={formData.title_2}
                      onChange={handleInputChange}
                      placeholder="Enter Title"
                    />
                  </div>
                </div>
              </div>

              <div className="row addIcon" id="addIcon">
                {iconFields.map((icon, index) => (
                  <div key={index} className="col-md-3 icon-field">
                    <div className="form-group">
                      <label>Description</label>
                      <input
                        type="text"
                        name={`description_2_${index}`}
                        className="form-control"
                        value={icon.description}
                        onChange={(e) =>
                          updateIconField(index, "description", e.target.value)
                        }
                        placeholder="Enter Description"
                      />
                    </div>
                    <div className="form-group">
                      <label>Upload File</label>
                      <input
                        type="file"
                        name={`file_upload_2_${index}`}
                        className="form-control"
                        onChange={(e) => handleIconFileChange(index, e)}
                      />
                    </div>
                    {icon.existingFile && (
                      <img
                        src={`${API_URL}${icon.existingFile}`}
                        style={{
                          maxHeight: "25px",
                          marginLeft: "20px",
                          marginTop: "-10px",
                        }}
                        alt="Existing file"
                      />
                    )}
                    <button
                      type="button"
                      className="btn btn-danger removeIcon mb-2"
                      onClick={() => removeIconField(index)}
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>

              <button
                type="button"
                className="addIconBtn btn btn-success mb-2"
                onClick={addIconField}
              >
                Add Icon
              </button>
              <hr />

              {/* Section 3 */}
              <div className="panel-heading mt-2">
                <span className="panel-title">Section 3</span>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Heading</label>
                    <input
                      type="text"
                      name="heading_3"
                      className="form-control"
                      value={formData.heading_3}
                      onChange={handleInputChange}
                      placeholder="Enter Heading"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Sub Heading</label>
                    <input
                      type="text"
                      name="sub_heading_3"
                      className="form-control"
                      value={formData.sub_heading_3}
                      onChange={handleInputChange}
                      placeholder="Enter Sub Heading"
                    />
                  </div>
                </div>

                {/* Stage Fields */}
                {[
                  "CuratedSelection",
                  "FundamentalAnalysis",
                  "TechnicalValidation",
                ].map((stageType) => (
                  <div key={stageType} className="col-md-4 icon-field">
                    <div className="form-group">
                      <label>{stageType}</label>
                      <input
                        type="text"
                        name={stageType}
                        className="form-control"
                        value={formData[stageType]}
                        onChange={handleInputChange}
                        placeholder={`Enter ${stageType}`}
                      />
                    </div>
                    <button
                      type="button"
                      className={`btn btn-primary add${stageType}`}
                      onClick={() => addStageField(stageType)}
                    >
                      Add Sub Title and Description
                    </button>
                    <div className={`subtitle-description-fields-${stageType}`}>
                      {stages[stageType].map((stage, index) => (
                        <div key={index} className="subtitle-description-pair">
                          <div className="form-group">
                            <label>Sub Title</label>
                            <input
                              type="text"
                              name={`sub_title_${stageType}[${index}]`}
                              className="form-control"
                              value={stage.sub_title}
                              onChange={(e) =>
                                updateStageField(
                                  stageType,
                                  index,
                                  "sub_title",
                                  e.target.value
                                )
                              }
                              placeholder="Enter Sub Title"
                            />
                          </div>
                          <div className="form-group">
                            <label>Description</label>
                            <input
                              type="text"
                              name={`description_${stageType}[${index}]`}
                              className="form-control"
                              value={stage.description}
                              onChange={(e) =>
                                updateStageField(
                                  stageType,
                                  index,
                                  "description",
                                  e.target.value
                                )
                              }
                              placeholder="Enter Description"
                            />
                          </div>
                          <button
                            type="button"
                            className="btn btn-danger removeSubtitleDescriptionBtn mt-2"
                            onClick={() => removeStageField(stageType, index)}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <hr />

              {/* Section 4 */}
              <div className="panel-heading mt-2">
                <span className="panel-title">Section 4</span>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      name="title_4"
                      className="form-control"
                      value={formData.title_4}
                      onChange={handleInputChange}
                      placeholder="Enter Heading"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Sub Title</label>
                    <input
                      type="text"
                      name="sub_title_4"
                      className="form-control"
                      value={formData.sub_title_4}
                      onChange={handleInputChange}
                      placeholder="Enter Sub Heading"
                    />
                  </div>
                </div>

                {/* Bullet Points */}
                {[1, 2, 3].map((num) => (
                  <div key={num} className="col-md-4 icon-field">
                    <div className="form-group">
                      <label>BulletPoints {num}</label>
                      <input
                        type="text"
                        name={`bulletPoints_${num}`}
                        className="form-control"
                        value={formData[`bulletPoints_${num}`]}
                        onChange={handleInputChange}
                        placeholder={`Enter bulletPoints ${num}`}
                      />
                    </div>
                    <div className="form-group">
                      <label>Upload File {num}</label>
                      <input
                        type="file"
                        name={`bulletPoints_file_${num}`}
                        className="form-control"
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>
                ))}

                {/* CTA Section */}
                <div className="col-md-4 icon-field">
                  <div className="form-group">
                    <label>CTA Text</label>
                    <input
                      type="text"
                      name="cta_text"
                      className="form-control"
                      value={formData.cta_text}
                      onChange={handleInputChange}
                      placeholder="Enter CTA Text"
                    />
                  </div>
                </div>
                <div className="col-md-4 icon-field">
                  <div className="form-group">
                    <label>CTA Link</label>
                    <input
                      type="text"
                      name="cta_link"
                      className="form-control"
                      value={formData.cta_link}
                      onChange={handleInputChange}
                      placeholder="Enter CTA Link"
                    />
                  </div>
                </div>
              </div>
              <hr />

              {/* Other Service */}
              <div className="panel-heading mt-2">
                <span className="panel-title">Other Service</span>
              </div>
              <div className="row">
                <div className="col-md-4 icon-field">
                  <div className="form-group">
                    <label>Other Service</label>
                    <Select
                      isMulti
                      name="other_service"
                      options={otherServices.map((service) => ({
                        value: service.id,
                        label: service.service_name,
                      }))}
                      value={otherServices
                        .filter((service) =>
                          formData.other_service.includes(service.id)
                        )
                        .map((service) => ({
                          value: service.id,
                          label: service.service_name,
                        }))}
                      onChange={handleOtherServiceChange}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select services"
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-lg-12">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={saving}
                  >
                    {saving ? "Saving..." : "Submit"}
                  </button>
                  <Link to="/Research/Services" className="btn btn-danger ml-2">
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </div>

        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <FontAwesomeIcon icon={faArrowUp} />
        </a>
      </div>
    </div>
  );
};

export default WebsiteServiceForm;
